import { gql, useApolloClient, useQuery } from "@apollo/client";

import { useGetIdentity } from "react-admin";

export const GET_ME = gql`
  query GetMe {
    getMe {
      id
      email
      isAdmin
      isAd
      deliveryNotesVisitor
      presetPassword
      userDefaultValues {
        id
        property
        value
      }
      selectedCompany {
        id
        name
        isBlocked
        ingresId
        carloPartnerId
        logo
        companyDefaultValues {
          id
          property
          value
        }
      }
      companies {
        id
        company {
          id
          name
          isBlocked
          logo
          ingresId
          carloPartnerId
        }
      }
    }
  }
`;

export function useProfile() {
  const apolloClient = useApolloClient();
  const { data } = useQuery(GET_ME, {
    fetchPolicy: "network-only",
  });

  const fetchMe = async () => {
    const { data } = await apolloClient.query({
      query: GET_ME,
      fetchPolicy: "network-only",
    });

    if (data?.getMe) {
      localStorage.setItem("user", JSON.stringify(data?.getMe));
    }

    return data;
  };

  return {
    user: data?.me,
    fetchMe,
  };
}
